import getApiClient from 'src/utils/getApiClient'
import type {
  DoctorSlotsRequest,
  DoctorSlotsResponse,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/api/apiDoctorSlots.types'

const apiClient = getApiClient()

const apiDoctorSlots = {
  post(payload: DoctorSlotsRequest) {
    return apiClient.post<DoctorSlotsResponse>(
      '/ajax/schedule/slots_bulk/',
      payload,
    )
  },
}

export default apiDoctorSlots
